
import { Device } from '../types';
import { mockSmartWaterMeters } from '@/lib/mock-data/water/smart-meters';
import { mockIoTGateways } from '@/lib/mock-data/water/gateways';
import { allWaterDevices } from '@/components/settings/data/water-devices';
import { 
  convertSmartMeterToDevice, 
  convertGatewayToDevice,
  convertStaticDevicesToGisDevices 
} from './converters';

/**
 * Generate water devices with real device IDs
 */
export const getWaterDevices = (): Device[] => {
  // Process meters and gateways
  const meterDevices = mockSmartWaterMeters.map((meter, index) => 
    convertSmartMeterToDevice(meter, 'Water', index % 20));
  
  const gatewayDevices = mockIoTGateways.map((gateway, index) => 
    convertGatewayToDevice(gateway, 'Water', index % 10));
  
  // Add static devices from settings
  const staticDevices = convertStaticDevicesToGisDevices(allWaterDevices, 40);
  
  return [...meterDevices, ...gatewayDevices, ...staticDevices];
};
